/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientProgramModel } from '../../models/patient-program-model';

export interface GetPatientPrograms$Params {
  patientID?: number;
  onlyActive?: boolean;
  lightLoad?: boolean;
}

export function GetPatientPrograms(http: HttpClient, rootUrl: string, params?: GetPatientPrograms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientProgramModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientPrograms.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
    rb.query('lightLoad', params.lightLoad, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientProgramModel>>;
    })
  );
}

GetPatientPrograms.PATH = '/api/Supervisor/GetPatientPrograms';
